export const IMAGE_CDN = 'https://webcdn.wujieai.com'

/** 必须是8, 6, 4的公倍数 */
export const PAGE_SIZE = 96
/** 创作中心-排行页数 */
export const CREATOR_CENTER_PAGE_SIZE = 20
export const RANK_PAGE_SIZE = 100
export const AI_QUICK_PAGE_SIZE = 25

// 积分充值金额限制(金额，不是积分)
export const MIN_POINT_RECHARGE = 10
export const MAX_POINT_RECHARGE = 50000

/** 无界ai协议缓存前缀key */
export const AGREEMENT_PRFIX_KEY = 'ai.config'

/** 文件类型转换 */
export const FileType: Record<string, string> = {
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  doc: 'application/msword',
  pdf: 'application/pdf',
  jpg: 'image/jpeg',
  png: 'image/png',
  webp: 'image/webp',
}

export const FarmatFileType: Record<string, string> = {
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'docx',
  'application/msword': 'doc',
  'application/pdf': 'pdf',
  'image/jpeg': 'jpg',
  'image/png': 'png',
}

/** 用户设备缓存key */
export const USER_DEVICE_KEY = 'user-device'
